var _path, _path2, _path3;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMeal = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.249 125.001H18.749C11.8428 125.001 6.24902 119.407 6.24902 112.501C6.24902 105.595 11.8428 100.001 18.749 100.001H131.249C138.155 100.001 143.749 105.595 143.749 112.501C143.749 119.407 138.155 125.001 131.249 125.001Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M75 37.5C43.9312 37.5 18.75 62.6812 18.75 93.75V100H131.25V93.75C131.25 62.6812 106.069 37.5 75 37.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.499 38.9437V31.25C87.499 24.3437 81.9053 18.75 74.999 18.75C68.0928 18.75 62.499 24.3437 62.499 31.25V38.9437C66.524 38.025 70.699 37.5 74.999 37.5C79.299 37.5 83.474 38.025 87.499 38.9437Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMeal, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/meal.0f59f019.svg";
export { ForwardRef as ReactComponent };